/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterTag
 */
export interface ClusterTag {
    /**
     * 
     * @type {string}
     * @memberof ClusterTag
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterTag
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClusterTag
     */
    systemTag: boolean;
}

/**
 * Check if a given object implements the ClusterTag interface.
 */
export function instanceOfClusterTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "systemTag" in value;

    return isInstance;
}

export function ClusterTagFromJSON(json: any): ClusterTag {
    return ClusterTagFromJSONTyped(json, false);
}

export function ClusterTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'],
        'systemTag': json['system_tag'],
    };
}

export function ClusterTagToJSON(value?: ClusterTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'value': value.value,
        'system_tag': value.systemTag,
    };
}

